export const APP_OVERLAY_TARGET = '#app-overlays'

export function resolveAppOverlayTarget(target?: string | HTMLElement): string | HTMLElement {
  return !target || target === 'body' || target === document.body ? APP_OVERLAY_TARGET : target
}
